import React from 'react';
// eslint-disable-next-line jira/restricted/moment
import moment from 'moment';
import { Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { INTERVAL, ROLLUP, EXPLICIT, DATE_FORMAT_MOMENT } from '../../../../constants/date.tsx';
import type { DateType } from '../../../../types/date.tsx';
import { RollupIcon } from '../../../rollup-icon/index.tsx';
import { SprintIcon } from '../../../sprint-icon/index.tsx';

export type Props = {
	dateType: DateType;
	date?: number;
	intervalName?: string;
	caption: string;
	noDateMessage: string;
};

const DependencyCardDateLabel = ({
	dateType,
	date,
	intervalName,
	caption,
	noDateMessage,
}: Props) => {
	const label = date !== undefined ? moment.utc(date).format(DATE_FORMAT_MOMENT) : noDateMessage;

	const renderExplicitDate = () => (
		<Container testId="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.explicit-date">
			{date !== undefined && `${caption} `}
			{label}
		</Container>
	);

	const renderIntervalDate = () => (
		<>
			{intervalName !== undefined && (
				<Container testId="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.interval-date">
					<SprintIcon />
					{intervalName}
				</Container>
			)}
			{renderExplicitDate()}
		</>
	);

	const renderRollupDate = () => (
		<Container testId="roadmap.timeline-table-kit.common.ui.dependency.card.date-label.rollup-date">
			{date !== undefined && `${caption} `}
			<RollupIcon />
			{label}
		</Container>
	);

	switch (dateType) {
		case INTERVAL:
			return renderIntervalDate();

		case ROLLUP:
			return renderRollupDate();

		case EXPLICIT:
		default:
			return renderExplicitDate();
	}
};

export default DependencyCardDateLabel;

const Container: React.FC<{ children: React.ReactNode; testId: string }> = ({
	children,
	testId,
}) => (
	<Flex xcss={ContainerStyles} direction="row" alignItems="center" testId={testId}>
		{children}
	</Flex>
);

const ContainerStyles = xcss({
	font: token('font.body.small'),
	paddingLeft: 'space.300',
	color: 'color.text.subtlest',
});
